import React from 'react'
import './check-out.style.scss'
import {connect} from 'react-redux'
import { selectCartItems, selectCartTotal } from '../../redux/cart/cart.selectors'
import {createStructuredSelector} from 'reselect'
import CheckoutItem from '../../components/checkout-item/checkout-item.component'
import StripeCheckoutButton from '../../components/stripe-button/stripe-button.component'



const CheckoutPage = ({cartItems, total}) => (
  <div className='checkout-page'>
    <div className='checkout-header'>

      <div className='header-block'>
        <span className='abd' >Product</span>
      </div>
      <div className='header-block'>
        <span className='abd' >Describtion</span>
      </div>
      <div className='header-block'>
        <span className='abd' >Quantity</span>
      </div>
      <div className='header-block'>
        <span className='abd' >Price</span>
      </div>
      <div className='header-block'>
        <span className='abd' >Remove</span>
      </div>
    </div> 
    {
      cartItems.map(item =>(<CheckoutItem key={item.id} item={item}/>))
    }
    <div>
      <span className='total'>Total: ${total}</span>
    </div>
    {total > 0 && <div className='test-warning'>
      *Please use the following test credit card for payments*
      <br/>
      4242 4242 4242 4242 - Exp: 01/21 - CVV: 123
    </div>}
    {total > 0 && <StripeCheckoutButton price={total} />}
    <div className='test-warning' style={{color: 'black'}} >
      Made By Khaled Nabil
    </div>
    
  </div>
)

const mapStateToProps = createStructuredSelector({
  cartItems: selectCartItems,
  total: selectCartTotal
})

export default connect(mapStateToProps)(CheckoutPage) 